import { render } from "./MdOverlay.vue?vue&type=template&id=558be5ac"
import script from "./MdOverlay.vue?vue&type=script&lang=js"
export * from "./MdOverlay.vue?vue&type=script&lang=js"

import "./MdOverlay.vue?vue&type=style&index=0&id=558be5ac&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__